<template>
  <v-container fill-height @keyup.enter="onSubmit()">
    <v-row align="center" justify="center">
      <v-col xs="12" md="6"
        ><v-card>
          <v-row class="justify-center">
            <v-col md="8" xs="12">
              <v-card-title>Login</v-card-title>
              <v-text-field outlined label="Email" v-model="email" />
              <v-text-field outlined label="Password" type="password" v-model="password" />
              <v-card-actions>
                <v-btn outlined class="gray">Reset</v-btn>
                <v-spacer />
                <router-link to="/register"><v-btn outlined class="blue" dark>Register</v-btn></router-link>
                <v-spacer />
                <v-btn outlined class="green" dark @click="onSubmit()">OK</v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="browserWarning" class="justify-center">
      <v-card>
        Your {{ browserType }} browser appears to be outdated. Please update your web browser or this site may not work as intended.
      </v-card>
    </v-row>
    <v-dialog v-model="noEmail" width="60%">
      <v-card height="200" class="d-flex justify-center align-center" @click="noEmail=false">
        This email is not registered. If you would like to register, please click the link below.
      </v-card>
    </v-dialog>
    <v-dialog v-model="passwordInvalid" width="60%">
      <v-card height="200" class="d-flex justify-center align-center" @click="passwordInvalid=false">
        Incorrect Password.
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      password: "",
      noEmail: false,
      passwordInvalid: false,
      browserWarning: false,
      browserType: "",
    };
  },
  methods: {
    async onSubmit() {
      const result = await axios({
        method: "post",
        url: process.env.VUE_APP_API_ADDRESS + "login",
        data: {
          email: this.email.toLowerCase(),
          password: this.password,
        },
        headers: {
          "content-type": "application/json",
        },
      });
      if (result.data == "account doesn't exist") return (this.noEmail = true);
      if (result.data == "incorrect password")
        return (this.passwordInvalid = true);
      if (result.data == "unsubscribed") return this.$router.push("inactive");
      this.localStorage.token = result.data.token;
      this.localStorage.accessLevel = result.data.accessLevel;
      this.localStorage.endDate = result.data.endDate;
      this.localStorage.email = result.data.email;
      if (this.localStorage.accessLevel == "admin") this.$router.push("admin");
      if (this.localStorage.accessLevel == "user")
        this.$router.push("dashboard");
    },
    compareVersions(left, right) {
      if (left == right) return 0;
      const arr1 = left.split(".").map((x) => parseInt(x, 10));
      const arr2 = right.split(".").map((x) => parseInt(x, 10));
      let i = 0;
      while (true) {
        if (arr1[i] < arr2[i]) return -1;
        if (arr1[i] > arr2[i]) return 1;
        i++;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      switch (vm.localStorage.accessLevel) {
        case "user":
          next("/dashboard");
          break;
        case "admin":
          next("/admin");
          break;
      }
      next();
    });
  },
  mounted() {
    this.browserType = this.$browserDetect.meta.name;
    switch (true) {
      case this.$browserDetect.isChrome &&
        this.compareVersions(this.$browserDetect.meta.version, "85") < 0:
        this.browserWarning = true;
        break;
      case this.$browserDetect.isChromeIOS &&
        this.compareVersions(this.$browserDetect.meta.version, "85") < 0:
        this.browserWarning = true;
        break;
      case this.$browserDetect.isSafari &&
        this.compareVersions(this.$browserDetect.meta.version, "13.1") < 0:
        this.browserWarning = true;
        break;
      case this.$browserDetect.isEdge &&
        this.compareVersions(this.$browserDetect.meta.version, "84") < 0:
        this.browserWarning = true;
        break;
      case this.$browserDetect.isFirefox &&
        this.compareVersions(this.$browserDetect.meta.version, "80") < 0:
        this.browserWarning = true;
        break;
      case this.$browserDetect.isOpera &&
        this.compareVersions(this.$browserDetect.meta.version, "69") < 0:
        this.browserWarning = true;
        break;
    }
  },
};
</script>

<style></style>
